import React from 'react';

// Feature Grid Section - Generic grid of feature cards
const FeatureGridSection = ({ data }) => {
  const { 
    heading, 
    subheading,
    features = [],
    columns = 3,
    background_color
  } = data || {};
  
  const bgStyle = background_color ? { backgroundColor: background_color } : {};
  
  const gridCols = {
    2: 'md:grid-cols-2',
    3: 'md:grid-cols-2 lg:grid-cols-3',
    4: 'md:grid-cols-2 lg:grid-cols-4',
  };
  
  if (!features || features.length === 0) {
    // Render with content/heading only if no features
    if (data?.content) {
      return (
        <section className="py-16 px-4" style={bgStyle}>
          <div className="max-w-4xl mx-auto">
            {heading && (
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 text-center">
                {heading}
              </h2>
            )}
            {subheading && (
              <p className="text-lg text-gray-600 mb-8 text-center">
                {subheading}
              </p>
            )}
            <div 
              className="rich-content prose prose-lg max-w-none text-gray-700"
              dangerouslySetInnerHTML={{ __html: data.content }}
            />
          </div>
        </section>
      );
    }
    return null;
  }
  
  return (
    <section className="py-16 px-4" style={bgStyle}>
      <div className="max-w-6xl mx-auto">
        {(heading || subheading) && (
          <div className="text-center mb-12">
            {heading && (
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                {heading}
              </h2>
            )}
            {subheading && (
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                {subheading}
              </p>
            )}
          </div>
        )}
        <div className={`grid grid-cols-1 ${gridCols[columns] || gridCols[3]} gap-6`}>
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow border border-gray-100"
            >
              {feature.icon && (
                <div className="text-4xl mb-4">{feature.icon}</div>
              )}
              {feature.image && (
                <img 
                  src={feature.image} 
                  alt={feature.title || ''} 
                  className="w-full h-40 object-cover rounded-lg mb-4"
                />
              )}
              {feature.title && (
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {feature.title}
                </h3>
              )}
              {feature.description && (
                <p className="text-gray-600">
                  {feature.description}
                </p>
              )}
              {feature.link && feature.link_label && (
                <a 
                  href={feature.link}
                  className="inline-block mt-4 text-blue-600 hover:text-blue-800 font-medium"
                >
                  {feature.link_label} →
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureGridSection;
